module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('span', [_vm._v("Using a referral code is optional, however, you may miss ")]), _c('router-link', {
    staticClass: "info-link mr-5",
    attrs: {
      "to": "/referrals",
      "target": "_blank"
    }
  }, [_vm._v("some useful benefits")]), _c('span', [_vm._v("if you don't have one. ")]), _c('span', [_vm._v("Don't worry, as you can set a referral code at any time later.")])], 1), _c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "field has-addons flex-1"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referralCode),
      expression: "referralCode"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.referralCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referralCode = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-medium",
    class: {
      'is-success': !_vm.hasErrors
    },
    attrs: {
      "disabled": _vm.hasErrors
    },
    on: {
      "click": _vm.select
    }
  }, [_c('span', [_vm._v("Next")])])])]), _c('p', {
    staticClass: "or"
  }, [_vm._v("OR")]), _c('button', {
    staticClass: "button is-medium flex-1 button-continue-without",
    on: {
      "click": _vm.continueWithoutReferral
    }
  }, [_vm._v("Continue without referral code")])]), (_vm.errorMessage) ? _c('p', {
    staticClass: "help help-small notif-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), (_vm.referredBySomeone) ? _c('p', {
    staticClass: "help help-small notif-grey"
  }, [_c('span', [_vm._v("Someone has sent you a link with their referral code ")]), _c('b', [_vm._v(_vm._s(_vm.referredBySomeone))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Use a referral code")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f06f25a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_referral.vue
// module id = 388
// module chunks = 1